import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SessionService } from '../session/session.service';
import { BalanceService } from '../../balance/balance.service';
import { SystemConfig } from '../../config/system-config';
import { TranslationService } from '../translation/translation.service';

@Injectable()
export class PayinService {

  constructor(private http: Http,
              public sessionService: SessionService,
              private balanceService: BalanceService,
              private translationService: TranslationService) {
  }

  payin(code: string): void {
    if (code.length === 16) {
      this.http.post(SystemConfig.Endpoint.PAYIN, {"Code": code}, {
        headers: new Headers()
      }).subscribe((response: Response) => this.handlePayinResponse(response),
          (error: Error) => this.handlePayinError());
    } else {
      this.sessionService.showInfoBubbleDialog(this.translationService.translate('punterBar.payin.invalidCode'), true);
    }
  }

  handlePayinResponse(response: Response) {
    this.balanceService.updateBalance();
    this.sessionService.hideFundsDialogs();
    this.sessionService.showInfoBubbleDialog(this.translationService.translate('punterBar.payin.success'), false);

  }

  handlePayinError(): void {
    this.sessionService.showInfoBubbleDialog(this.translationService.translate('default.error'), true);
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/payin/payin.service.ts